export const locale = {
    lang: 'pt',
    data: {
        FORM_VALIDATION: {
            REQUIRED: 'Campo obrigatório',
            INVALID_DATE: 'Campo deve ter o formato {{ format }}',
            MAX_DATE: 'Campo deve ser no máximo {{ max }}',
            MIN_DATE: 'Campo deve ser no mínimo {{ min }}',
            NOT_WEEKEND: 'Campo não permite final de semana',
            URL: 'Campo deve ser uma URL válida',
            EMAIL: 'Campo deve ser um e-mail válido',
            MIN_LENGTH: 'Campo deve ter no mínimo {{ min }} caracteres',
            MAX_LENGTH: 'Campo deve ter no máximo {{ max }} caracteres',
            NUMBER: 'Campo deve ser um número',
            NUMBER_INTEGER: 'Campo deve ser um número inteiro',
            MAX_NUMBER: 'Campo deve ser no máximo {{ max }}',
            MIN_NUMBER: 'Campo deve ser no mínimo {{ min }}',
            LETTER_AND_NUMBER: 'Campo permite somente letras e números',
            MASK: 'Campo deve estar no formato correto',
            UUID: 'Campo deve ser um UUID',
            LETTER: 'Campo permite somente letras',
            DISABLE_MINUTE: 'Campo não permite minutos',
            REGEXP: 'Campo não está no formato correto',
            INVALID_DOCUMENT: 'Documento inválido',
            MUST_MATCH: 'Os campos devem ser iguais',
            MINIMUM_TWO_NAMES: 'Informe o nome completo (nome e sobrenome)',
            DUPLICATE_NAMES_NOT_ALLOWED: 'O primeiro e segundo nome não podem ser iguais',
            STRONG_PASSWORD: 'Senha deve conter pelo menos uma letra maiúscula, uma minúscula, um número e um caracter especial',
            CARD_NUMBER_INVALID: 'Número de cartão inválido',
        },
    },
};
